<!-- B2B Document Setup Modal -->
<div class="b2b-doc-setup">

  <!-- ── HEADER ── -->
  <div class="header">
    <div class="header-left">
      <ng-icon name="tablerFileDescription" class="header-icon"></ng-icon>
      <div>
        <h4 *ngIf="mode === 'customer'">Configure Document Requirements</h4>
        <h4 *ngIf="mode === 'supplier'">Document Requirements from {{ peerBusinessName }}</h4>
        <p class="header-sub" *ngIf="mode === 'customer'">
          Select which documents you require from <strong>{{ peerBusinessName }}</strong> and mark them as Mandatory or Optional.
        </p>
        <p class="header-sub" *ngIf="mode === 'supplier'">
          Review and upload the documents requested by <strong>{{ peerBusinessName }}</strong>.
        </p>
        <p class="security-note">
          <ng-icon name="tablerLock"></ng-icon>
          <span *ngIf="mode === 'customer'">END-TO-END ENCRYPTED &amp; SECURE. Only you and <strong>{{ peerBusinessName }}</strong> can view the documents you request.</span>
          <span *ngIf="mode === 'supplier'">END-TO-END ENCRYPTED &amp; SECURE. Only you and <strong>{{ peerBusinessName }}</strong> can view the uploaded documents.</span>
        </p>
      </div>
    </div>
    <button class="btn btn-sm btn-light close-btn" (click)="mode === 'customer' ? skipCustomer() : closeSupplier()">
      <ng-icon name="tablerX"></ng-icon>
    </button>
  </div>

  <!-- ── CONTENT ── -->
  <div class="content">

    <!-- Loading -->
    <ng-container *ngIf="loading">
      <app-common-skeleton [NameOftheScreen]="'smallcard'" [countforView]="4"></app-common-skeleton>
    </ng-container>

    <!-- ════ CUSTOMER MODE ════ -->
    <ng-container *ngIf="!loading && mode === 'customer'">

      <!-- Empty state -->
      <div *ngIf="templateGroups.length === 0" class="empty-state">
        <ng-icon name="tablerFolder" class="empty-icon"></ng-icon>
        <p>No document templates found for your business.</p>
        <p class="empty-sub">Add document templates in your Company Documents section first.</p>
      </div>

      <!-- Template groups accordion -->
      <div class="documents-accordion">
        <div *ngFor="let group of templateGroups" class="accordion-item">

          <!-- Accordion header -->
          <div class="accordion-header" [class.expanded]="group.expanded" (click)="toggleGroup(group)">
            <div class="header-left">
              <div class="doc-info">
                <ng-icon name="tablerFileDescription" class="doc-icon"></ng-icon>
                <span class="doc-name">{{ group.category }}</span>
                <span class="doc-count-badge">{{ group.templates.length }} doc{{ group.templates.length !== 1 ? 's' : '' }}</span>
              </div>
            </div>
            <div class="header-right">
              <ng-icon class="accordion-chevron" [name]="group.expanded ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
            </div>
          </div>

          <!-- Accordion body -->
          <div class="accordion-body" *ngIf="group.expanded">
            <div *ngFor="let template of group.templates" class="template-row">

              <!-- Custom checkbox + name -->
              <label class="custom-checkbox-wrapper">
                <input
                  type="checkbox"
                  [id]="'chk-' + template.comDocumentId"
                  [(ngModel)]="selections[template.comDocumentId].included"
                  (ngModelChange)="selections[template.comDocumentId].isMandatory = $event">
                <span class="custom-checkmark"></span>
                <span class="template-name">{{ template.documentName }}</span>
              </label>

              <!-- Already Required badge -->
              <span *ngIf="selections[template.comDocumentId]?.alreadyRequired" class="badge badge-already">
                Already Required
              </span>

              <!-- Mandatory / Optional toggle: unchecked = Optional shown; checked = Mandatory only -->
              <div class="mandatory-toggle">
                <label class="radio-option active" *ngIf="selections[template.comDocumentId]?.included">
                  <span class="badge badge-mandatory">Mandatory</span>
                </label>
                <label class="radio-option active" *ngIf="!selections[template.comDocumentId]?.included">
                  <span class="badge badge-optional">Optional</span>
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- ════ SUPPLIER MODE ════ -->
    <ng-container *ngIf="!loading && mode === 'supplier'">

      <!-- Empty state -->
      <div *ngIf="supplierRows.length === 0" class="empty-state">
        <ng-icon name="tablerInbox" class="empty-icon"></ng-icon>
        <p>No document requirements have been set by <strong>{{ peerBusinessName }}</strong> yet.</p>
        <p class="empty-sub">You can revisit this later in the Business Contacts section.</p>
      </div>

      <!-- Supplier document rows -->
      <div *ngFor="let row of supplierRows" class="supplier-doc-row">

        <!-- Hidden file input at row level so it's accessible in all child sections -->
        <input
          type="file"
          [id]="'file-' + row.template.comDocumentId"
          hidden
          [accept]="row.template.allowedFileTypes || '*'"
          (click)="fileInput.value=''"
          (change)="onFileSelected($event, row)"
          #fileInput>

        <!-- Doc info -->
        <div class="supplier-doc-info">
          <ng-icon name="tablerFileDescription" class="doc-icon"></ng-icon>
          <div class="supplier-doc-meta">
            <span class="supplier-doc-name">{{ row.template.documentName }}</span>
            <span class="supplier-doc-cat text-muted">{{ row.template.documentCategory }}</span>
          </div>
        </div>

        <!-- Badges row -->
        <div class="supplier-doc-badges">
          <span class="badge badge-mandatory" *ngIf="row.checklist?.isMandatory">Mandatory</span>
          <span class="badge badge-optional" *ngIf="!row.checklist?.isMandatory">Optional</span>

          <span class="badge status-verified" *ngIf="getUploadStatus(row) === 'VERIFIED'">
            <ng-icon name="tablerCircleCheck"></ng-icon> Verified
          </span>
          <span class="badge status-submitted" *ngIf="getUploadStatus(row) === 'SUBMITTED'">
            <ng-icon name="tablerClock"></ng-icon> Submitted
          </span>
          <span class="badge status-not-uploaded" *ngIf="getUploadStatus(row) === 'NOT_UPLOADED'">
            <ng-icon name="tablerAlertCircle"></ng-icon> Not Uploaded
          </span>
        </div>

        <!-- Upload button (hidden if already verified) -->
        <div class="supplier-doc-actions" *ngIf="getUploadStatus(row) !== 'VERIFIED'">
          <button
            class="btn btn-sm btn-upload"
            (click)="onUploadClick(row, fileInput)"
            [disabled]="row.uploading || row.checkingVault">
            <ng-icon name="tablerLoader2" class="spin" *ngIf="row.uploading || row.checkingVault"></ng-icon>
            <ng-icon name="tablerUpload" *ngIf="!row.uploading && !row.checkingVault"></ng-icon>
            {{ row.uploading ? 'Uploading...' : row.checkingVault ? 'Checking...' : getUploadStatus(row) === 'SUBMITTED' ? 'Re-upload' : 'Upload' }}
          </button>
        </div>

        <!-- Vault selection panel (inline) -->
        <div class="vault-panel" *ngIf="row.showVaultPanel">
          <div class="vault-panel-header">
            <ng-icon name="tablerShieldLock"></ng-icon>
            <span>Select from your Vault</span>
          </div>
          <div class="vault-docs-list">
            <label
              *ngFor="let vd of row.vaultDocs"
              class="vault-doc-item"
              [class.selected]="row.selectedVaultId === vd.vaultDocumentId">
              <input
                type="radio"
                [name]="'vault-' + row.template.comDocumentId"
                [value]="vd.vaultDocumentId"
                [(ngModel)]="row.selectedVaultId">
              <div class="vault-doc-details">
                <span class="vault-doc-name">{{ vd.fileName || vd.documentName }}</span>
                <span class="vault-doc-meta text-muted">
                  Rev {{ vd.currentRevision || 1 }}
                  <ng-container *ngIf="vd.fileSize"> · {{ (vd.fileSize / 1024 / 1024).toFixed(2) }} MB</ng-container>
                </span>
              </div>
            </label>
          </div>
          <div class="vault-panel-footer">
            <button class="btn btn-sm btn-secondary" (click)="cancelVaultPanel(row, fileInput)">
              Upload New
            </button>
            <button
              class="btn btn-sm btn-primary"
              (click)="useVaultDoc(row)"
              [disabled]="!row.selectedVaultId || row.uploading">
              <ng-icon name="tablerLoader2" class="spin" *ngIf="row.uploading"></ng-icon>
              Use Selected
            </button>
          </div>
        </div>

      </div>

    </ng-container>

  </div>

  <!-- ── FOOTER ── -->
  <div class="modal-footer">

    <!-- Customer mode footer -->
    <ng-container *ngIf="mode === 'customer'">
      <button class="btn btn-secondary" (click)="skipCustomer()" [disabled]="saving">
        Skip for Now
      </button>
      <button
        class="btn btn-primary"
        (click)="saveCustomer()"
        [disabled]="saving || !hasAnySelection || loading">
        <ng-icon name="tablerLoader2" class="spin" *ngIf="saving"></ng-icon>
        Save Requirements
      </button>
    </ng-container>

    <!-- Supplier mode footer -->
    <ng-container *ngIf="mode === 'supplier'">
      <button class="btn btn-primary" (click)="closeSupplier()">
        Done
      </button>
    </ng-container>

  </div>

</div>
